// "Task Title Display Mode" setting, mirroring Android's task_title_display_mode
// (DataStore). localStorage only on web. Values match the Android enum names so
// the two stay in step; default MARQUEE (scrolling), like Android.
export const TITLE_MODE_KEY = "task_title_display_mode";

export const TITLE_MODES = {
  MARQUEE: "MARQUEE",
  SINGLE_LINE: "SINGLE_LINE",
  MULTIPLE_LINES: "MULTIPLE_LINES",
};

// label matches Android's TaskTitleDisplayMode value strings.
export const TITLE_MODE_OPTIONS = [
  { value: TITLE_MODES.MARQUEE, label: "Scrolling" },
  { value: TITLE_MODES.SINGLE_LINE, label: "Single Line" },
  { value: TITLE_MODES.MULTIPLE_LINES, label: "Multiple Lines" },
];

export const getTitleDisplayMode = () => {
  try {
    const v = localStorage.getItem(TITLE_MODE_KEY);
    return TITLE_MODES[v] ? v : TITLE_MODES.MARQUEE;
  } catch (e) {
    return TITLE_MODES.MARQUEE;
  }
};

export const setTitleDisplayMode = (mode) => {
  try {
    localStorage.setItem(TITLE_MODE_KEY, mode);
  } catch (e) {
    /* ignore */
  }
};
